import * as respondToTrigger from './respond-to-trigger';

export const responsesNodes = {
  'respond-to-trigger': respondToTrigger,
};
